<template>
  <main>
    <div class="table-filter">
      <input id="admin-search-movies" type="text" v-model="moviesQuery" v-on:keyup.enter="doMovieSearch" placeholder="Search movies" />
      <button id="btnDoSearch" v-on:click="doMovieSearch()" class="pure-button">Search</button>
      <button id="btnClearSearch" v-on:click="clearSearch()" class="pure-button">Clear</button>
      <p>Results: {{resultsCount}}</p>
    </div>
    <HotTable :root="root" ref="moviesTable" :settings="hotSettings" :onAfterChange="afterChangeHandler"></HotTable>
  </main>
</template>

<script>
/* global $ */
import HotTable from 'vue-handsontable-official'
import firebase from 'firebase'
import db from './firebaseInit'

export default {
  data: function () {
      return {
        root: 'matrix-table',
        movies: [],
        moviesQuery: '',
        searchLimit: 200,
        pageLimit: 20000,
        resultsCount: 0,
        hotSettings: {
          data: this.movies,
          rowHeaders: true,
          contextMenu: true,
          stretchH: 'all',
          autoWrapRow: true,
          className: 'htCenter htMiddle',
          columnSorting: true,
          sortIndicator: true,
          observeChanges: false,
          colHeaders: ['Doc ID', 'Quality', 'Title', 'Director', 'Year', 'Plot', 'RTConsensus', 'Genre', 'Cast', 'Language', 'Production', 'Poster', 'RTUserReviews', 'RTUser35', 'imdbVotes', 'imdb35', 'letterboxdVotes', 'RTCriticReviews', 'RTCrit35', 'Buzz', 'StatNumber', 'statPercentile', 'Stat30', 'Stat100', 'RTCriticMeter', 'RTUserMeter', 'imdb10', 'LetterboxdScore', 'Metacritic'],
          rowHeights: 50,
          colWidths: [100, 80, 120, 120, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150],
          columns: [
            {data: 'docID', readOnly: true},
            {data: 'Quality', type: 'numeric'},
            {data: 'Title', type: 'text'},
            {data: 'Director', type: 'text'},
            {data: 'Year', type: 'numeric'},
            {data: 'Plot', type: 'text'},
            {data: 'RTConsensus', type: 'text'},
            {data: 'Genre', type: 'text'},
            {data: 'Cast', type: 'text'},
            {data: 'Language', type: 'text'},
            {data: 'Production', type: 'text'},
            {data: 'Poster', type: 'text'},
            {data: 'RTUserReviews', type: 'numeric'},
            {data: 'RTUser35', type: 'numeric'},
            {data: 'imdbVotes', type: 'numeric'},
            {data: 'imdb35', type: 'numeric'},
            {data: 'letterboxdVotes', type: 'numeric'},
            {data: 'RTCriticReviews', type: 'numeric'},
            {data: 'RTCrit35', type: 'numeric'},
            {data: 'Buzz', type: 'numeric'},
            {data: 'StatNumber', type: 'numeric'},
            {data: 'statPercentile', type: 'numeric'},
            {data: 'Stat30', type: 'numeric'},
            {data: 'Stat100', type: 'numeric'},
            {data: 'RTCriticMeter', type: 'numeric'},
            {data: 'RTUserMeter', type: 'numeric'},
            {data: 'imdb10', type: 'numeric'},
            {data: 'LetterboxdScore', type: 'numeric'},
            {data: 'Metacritic', type: 'numeric'},
          ]
        }
      }
    },
    name: 'grapevinematrix',
    components: {
      HotTable
    },
    created () {
      let vm = this
      vm.getMovies()
      /* Set Context Menu */
      vm.hotSettings.contextMenu = {
        callback: function (key, options) {
          if (key === 'about') {
            setTimeout(function () {
              // timeout is used to make sure the menu collapsed before alert is shown
              alert('This is a context menu with default and custom options mixed')
            }, 100)
          }
        },
        items: {
          'hsep2': '---------',
          'about': {name: 'About this menu'}
        }
      }
      /* Set Change Callback */
      vm.hotSettings.afterChange = vm.afterChangeHandler()
    },
    methods: {
      getMovies: function () {
        // let vm = this
        // var moviesRef = db.collection('movies').limit(vm.pageLimit)
        // moviesRef.get().then((querySnapshot) => {
        //   console.log('created query: ' + querySnapshot.docs.length)
        //   querySnapshot.forEach((doc) => {
        //     var movieData = doc.data()
        //     movieData.docID = doc.id
        //     this.movies.push(movieData)
        //   })
        //   /* Load Data */
        //   vm.$refs.moviesTable.table.loadData(vm.movies)
        // })
        let vm = this
        var client = algoliasearch('EQ4MPZHE99', 'b883b4278df4fd23853990e7ed74551d')
        var index = client.initIndex('movies')
        index.search({
          hitsPerPage: vm.pageLimit
        }).then(responses => {
          // Response from Algolia:
          // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
          var results = responses.hits
          vm.resultsCount = results.length
          console.log('number of results: ' + results.length)
          for (var i = 0; i < results.length; i++) {
            var movieData = results[i]
            if (movieData.Genres) {
              movieData.Genre = movieData.Genres.join(', ')              
            }
            if (movieData.Cast && $.isArray(movieData.Cast)) {
              movieData.Cast = movieData.Cast.join(', ')              
            }
            if (movieData.Directors) {
              movieData.Director = movieData.Directors.join(', ')              
            }
            vm.movies.push(movieData)
          }
          /* Load Data */
          vm.$refs.moviesTable.table.loadData(vm.movies)
        })
      },
      doMovieSearch: function () {
        let vm = this
        vm.movies = []
        var client = algoliasearch('EQ4MPZHE99', 'b883b4278df4fd23853990e7ed74551d')
        var index = client.initIndex('movies')
        var query = vm.moviesQuery
        index.search({
          query: query,
          hitsPerPage: vm.pageLimit
        }).then(responses => {
          // Response from Algolia:
          // https://www.algolia.com/doc/api-reference/api-methods/search/#response-format
          var results = responses.hits
          vm.resultsCount = results.length
          console.log('number of results: ' + results.length)
          for (var i = 0; i < results.length; i++) {
            var movieData = results[i]
            if (movieData.Genres) {
              movieData.Genre = movieData.Genres.join(', ')              
            }
            if (movieData.Cast) {
              movieData.Cast = movieData.Cast.join(', ')              
            }
            if (movieData.Directors) {
              movieData.Director = movieData.Directors.join(', ')              
            }
            vm.movies.push(movieData)
          }
          /* Load Data */
          vm.$refs.moviesTable.table.loadData(vm.movies)
        })
      },
      afterChangeHandler: function (changes, source) {
        if (arguments[1] !== 'loadData') {
          if (!changes) {
            return
          }
          for (var i = 0, iLen = changes.length; i < iLen; i += 1) {
            if (changes[i][2] !== changes[i][3]) {
              console.log('trying to change')
              let logicalIndex = this.$refs.moviesTable.table.runHooks('modifyRow', changes[i][0])
              let changedDocID = this.$refs.moviesTable.table.getDataAtCell(changes[i][0], 0)
              let newData = this.$refs.moviesTable.table.getSourceDataAtRow(logicalIndex)
              delete newData._highlightResult
              delete newData.objectID
              console.log(changedDocID)
              console.log(newData)
              if (changedDocID) {
                this.processChange(changedDocID, newData)
              }
            }
          }
        }
      },
      processChange (docID, newData) {
        console.log('trying to update grape')
        let vm = this
        var movieRef = db.collection('movies').doc(docID)
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()
        delete newData.createdTimestamp
        newData.updatedTimestamp = timestamp
        console.log(docID)
        movieRef.update(newData)
        .then(function (docRef) {
          console.log('Document ' + docID + ' successfully updated!')
          newData.docID = docID
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      }
    }
};
</script>

<style>
  #matrix-table {
    width: 100%;
    height: 100vh;
    height: calc(100vh - 80px);
    margin-top: 4px;
    overflow: hidden;
  }
  #matrix-table th {
    vertical-align: middle;
  }
  #matrix-table td {
    max-width: 320px;
    min-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    padding: 0 10px;
  }
  #matrix-table thead th .relative {
    padding: 4px 8px;
  }
</style>
<style scoped>
  .table-filter {
    padding: 10px 0;
  }
  .table-filter input {
    height: 40px;
    width: 300px;
    padding: 4px 10px;
    box-sizing: border-box;
  }
  .table-filter .pure-button {
    vertical-align: top;
    height: 40px;
  }
  .table-filter p {
    display: inline-block;
    margin: 0 0 0 15px;
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue